module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADASURBVHgBrVKBEYMgDAxdREfoBrqBbGA3KBvoZnYDugFs4Ag0uXuuWkG4tn/3J5LPJxAUJRBC6PnT4tcrpR5UA040zDUc4ZhjKXmGeGEOzAaUtUVsziXfIJhOCkzQmFRQWrRUPqJ0t35u9nAeKgw0tH3cu9D7tp9URtQ0W4OfIAYe62uFPmr8bhezX0rZGKdLBczpnGn3TsacIM7Z4rZbUGN8oVQkPigXjpAj3jdF8iYw6qRVsMt0auhboBtN/8ALH1AZjja7BY8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ss.png
// module id = P1Vi
// module chunks = 1